<template>
    <page :showBackButton="true">
        <h2 v-if="directContact">Bitte wähle einen Berater aus</h2>
        <h1 v-else>Berater</h1>
        <!-- <template v-slot:header>
      <ion-title>Berater</ion-title>
    </template> -->

        <ion-grid>
            <ion-row v-if="Object.keys($store.state.coaches.all).length > 0">
                <ion-col
                    v-for="(coach, coachKey) in $store.state.coaches.all"
                    :key="coachKey"
                    size="12"
                    size-md="6"
                >
                    <coach-card
                        :contractId="coachKey"
                        :directContact="directContact"
                    ></coach-card>
                </ion-col>
            </ion-row>

            <ion-row v-else>
                <ion-col
                    v-for="coachKey in 6"
                    :key="coachKey"
                    size="12"
                    size-md="6"
                >
                    <coach-card></coach-card>
                </ion-col>
            </ion-row>
        </ion-grid>
    </page>
</template>

<script>
import CoachCard from "@/components/CoachCard";
import Page from "@/components/Page";
import storage from "@/utils/storage";

export default {
    components: {
        Page,
        CoachCard,
    },
    props: {
        directContact: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    mounted() {
        storage.setStoreData().then(() => {
            for (let contractKey in this.$store.state.contracts) {
                this.$store.cache.dispatch(
                    "coaches/getCoach",
                    this.$store.state.contracts[contractKey].ContractId
                );
            }
        });
    },
    computed: {
        // groupedCoaches() {
        //   let result = [];
        //   for (let coachKey in this.$store.state.coaches.all) {
        //   }
        // }
    },
};
</script>

<style></style>
